module.exports = __webpack_public_path__ + "static/img/benefit@3x.035b29de.png";